import emailAddresses from 'email-addresses';
import * as _ from 'lodash-es';

const DOMAINS = [
  'gmail.com',
  'hotmail.com',
  'outlook.com',
  'yahoo.com',
  'icloud.com',
];

const parseEmail = (email: string) =>
  emailAddresses.parseOneAddress(email) ? email : '';

const getSuggestedEmail = (inputValue: string, organizationEmail: string) => {
  if (!inputValue) {
    return '';
  }
  const lowerCaseValue = inputValue.toLowerCase();
  const address = emailAddresses.parseOneAddress(lowerCaseValue);

  const [local = '', detectedDomain] =
    address?.type === 'mailbox'
      ? [address.local, address.domain]
      : lowerCaseValue.split('@');

  if (!detectedDomain) {
    return parseEmail(`${local}@${organizationEmail}`);
  }

  const suggestedDomain = [organizationEmail, ...DOMAINS].find((domain) =>
    domain.startsWith(detectedDomain),
  );

  if (suggestedDomain) {
    return parseEmail(`${local}@${suggestedDomain}`);
  }

  const domainParts = detectedDomain.split('.');
  const hasTopLevelDomain = !!(domainParts.length > 1 && _.last(domainParts));

  const enhancedDomain = hasTopLevelDomain
    ? detectedDomain
    : `${detectedDomain}${detectedDomain.endsWith('.') ? 'com' : '.com'}`;

  return parseEmail(`${local}@${enhancedDomain}`);
};

export default getSuggestedEmail;
